import React from 'react';
import _ from 'lodash';

import { useReturnAuthorizationSummarySectionQuery } from 'generated/graphql';
import { NetSuiteRecordChip } from 'modules/layer00';
import { DateTime } from 'luxon';



export interface ILineItem {
  id: string;
  sku: string;
  productName: string;
  serialNumber: string;
  quantity: number;
  reasonForReturn: string;
}

export interface IReturnAuthorization {
  storeId: string;
  orderId: string;
  customerId: string;
  customerFullName: string;
  orderDate: DateTime;
  orderNumber: string;
  returnNumber: string;

  customerWriteStatus: NetSuiteRecordChip.IWriteStatus;
  orderWriteStatus: NetSuiteRecordChip.IWriteStatus;
  returnAuthorizationWriteStatus: NetSuiteRecordChip.IWriteStatus;

  lineItems: ILineItem[];
}

export interface IData {
  returnAuthorization: IReturnAuthorization | null;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useReturnAuthorizationSummarySectionQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const returnAuthorization = tuple.data?.returnAuthorization;
      const data: IData = {
        returnAuthorization: {
          customerFullName: returnAuthorization?.customer.firstName + ' ' + returnAuthorization?.customer.lastName,
          customerId: returnAuthorization?.customer.id ?? '',
          orderDate: DateTime.fromISO(returnAuthorization?.order.orderDate ?? ''),
          orderId: returnAuthorization?.order.id ?? '',
          storeId: returnAuthorization?.store.id ?? '',
          orderNumber: returnAuthorization?.order.orderNumber ?? '',
          returnNumber: returnAuthorization?.returnNumber ?? '',
          customerWriteStatus: NetSuiteRecordChip.genWriteStatus({
            netSuiteRecord: returnAuthorization?.customer.netSuiteRecord,
            writeRequest: returnAuthorization?.customer.netSuiteWriteRequest
          }),
          orderWriteStatus: NetSuiteRecordChip.genWriteStatus({
            netSuiteRecord: returnAuthorization?.order.netSuiteRecord,
            writeRequest: returnAuthorization?.order.netSuiteWriteRequest
          }),
          returnAuthorizationWriteStatus: NetSuiteRecordChip.genWriteStatus({
            netSuiteRecord: returnAuthorization?.netSuiteRecord,
            writeRequest: returnAuthorization?.netSuiteWriteRequest
          }),
          lineItems: _.map(tuple.data?.returnAuthorization?.lineItems, (lineItem): ILineItem => ({
            id: lineItem.id,
            productName: lineItem.product.name,
            sku: lineItem.product.sku,
            quantity: lineItem.quantity,
            serialNumber: lineItem.serialNumber,
            reasonForReturn: lineItem.reasonForReturn
          }))
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
